var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ItpPage",
    {
      attrs: {
        size: _vm.size,
        header: _vm.documentTitle,
        loaded: _vm.loaded,
        noShow: !_vm.loaded,
        modal: _vm.modal,
        "itp-cname": "TemplatePreview",
        modalBindings: _vm.b_7315092382398562_modalBindings
      },
      on: {
        close: function($event) {
          return _vm.evh_7315092382398562_close($event, {})
        }
      }
    },
    [
      _vm.loaded
        ? _c(
            "UcHeader",
            {
              attrs: {
                slot: "header",
                card: !_vm.modal,
                modal: _vm.modal,
                title: _vm.documentTitle
              },
              on: {
                close: function($event) {
                  return _vm.evh_2248226175642056_close($event, {})
                }
              },
              slot: "header"
            },
            [
              _c("ItpButton", {
                staticClass: "mx-3",
                attrs: {
                  variant: "default",
                  icon: "fa-sync-alt",
                  text: _vm._f("gettext")("Reload"),
                  spinning: _vm.actions.reload.isRunning || _vm.isPDFLoading
                },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    $event.stopPropagation()
                    return _vm.evh_8564662037462133_clickPreventStop($event, {})
                  }
                }
              }),
              _vm._v(" "),
              !_vm.file
                ? _c("DIV", [_vm._v("\n      Loading...\n    ")])
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded
        ? _c(
            "UcBody",
            {
              staticClass: "h-100",
              attrs: { card: !_vm.modal, modal: _vm.modal }
            },
            [
              _vm.file
                ? _c("ItpPdfViewer", {
                    staticClass: "h-100",
                    attrs: { file: _vm.file }
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.sampleData
                ? _c(
                    "DIV",
                    { staticClass: "h-100 d-flex" },
                    [
                      _c(
                        "b-alert",
                        {
                          staticClass: "m-auto",
                          attrs: { show: "", variant: "primary" }
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                _vm._f("pgettext")(
                                  "Generate HTML previews using the data loaded/entered at the Data tab.",
                                  "Templates"
                                )
                              ) +
                              "\n      "
                          )
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded
        ? _c(
            "UcFooter",
            {
              attrs: { slot: "footer", card: !_vm.modal, modal: _vm.modal },
              slot: "footer"
            },
            [
              _c("ItpButton", {
                attrs: {
                  text: _vm._f("pgettext")("Close", "Templates"),
                  variant: "default"
                },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    $event.stopPropagation()
                    return _vm.evh_1548630417156826_clickPreventStop($event, {})
                  }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded ? _c("template", { slot: "footer" }) : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }